import euLogo from "./img/EU.png";
const Funding = () => {
  return (
    <div
      className="funding"
      style={{
        position: "absolute",
        left: "0px",
        bottom: "0px",
        background: "rgb(255 255 255 / 85%)",
        zIndex: 10,
        borderRadius: "5px",
        padding: "3px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className="eu-icon">
        <img src={euLogo} style={{ width: "50px" }}></img>
      </div>
      <p style={{ fontSize: ".6rem", width: "170px", fontStyle: "italic" }}>
        Project funded from the EU HE research and innovation programme under GA
        No. 101094818
      </p>
    </div>
  );
};

export default Funding;
